"use strict";

import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Loader } from 'google-maps';

import { delay } from '../../utils';

class Search extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      options: [],
      defaultSelected: [],
    };

    this._handleSelection = this._handleSelection.bind(this);
    this._handleTextChange = this._handleTextChange.bind(this);
  };

  static propTypes = {
    onSelection: React.PropTypes.func,
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.object
    ])
  };

  componentWillMount() {
    const { value } = this.props;

    if(value) {
      this.setState({ options: [{ name: value }], defaultSelected: [{ name: value }] });
    }

    if (typeof window === 'undefined') {
      return;
    }

    let loader = new Loader("AIzaSyArtCCIbgY9HPt_bM1I3u2x0hNXfdmMEds", {
      libraries: ["places"],
    });

    loader
      .load()
      .then((google) => {
        this.autocompleteService = new google.maps.places.AutocompleteService();
      })
      .catch((error) => {
        console.error("Google map api was not found in the page.");
        console.error(error);
      });
  };

  render() {
    const { options, defaultSelected } = this.state;

    return(
      <Typeahead
        options={ options }
        labelKey="name"
        defaultSelected={ defaultSelected }
        onInputChange={ this._handleTextChange }
        onChange={ this._handleSelection }
        placeholder="Search Places..."
        renderMenuItemChildren={ result => { return <strong key="name">{ result.name }</strong> }}/>
    );
  };

  _handleOrganizationStore(state) {
    if(state._searchResults) {
      this.setState({ options: state._searchResults });
    }
  };

  _handleSelection(values) {
    if(values && values.length) {
      setTimeout(() => {
        this.props.onSelection(values[0].name);
      }, 50);
    }
  };

  _handleTextChange(value) {
    const self = this;
    console.log("enter in text change");
    if(value) {
      delay(() => {
        self.autocompleteService.getPlacePredictions({ input: value }, suggestions => {
          if(suggestions){
            const options = suggestions.map(suggestion => { return { name: suggestion.description }; });
            self.setState({ options: options })
          }
        });
      }, 250);
    }
  };
}

export default Search;
